import { ADJUSTMENT_VALUE_CENTS_RANGE, ESTIMATE_NOTE_MAX_LENGTH, adjustmentKeySchema, adjustmentSuggestionValuesSchema, conditionRatingSchema, dateStringValidation, estimateSourceSchema, renovatedYearSchema, suggestibleAdjustmentKeySchema, unitFeatureKeySchema, utilityKeySchema, utilityPayerSchema, } from '@teo/types';
import { z } from 'zod';
import { displayId } from './common.js';
const noteSchema = z.string().trim().max(ESTIMATE_NOTE_MAX_LENGTH);
export const saveUnitNoteSchema = z.object({ unitId: displayId, note: noteSchema });
export const savePropertyNoteSchema = z.object({ propertyId: displayId, note: noteSchema });
export const unitProfileChangeSchema = z.discriminatedUnion('field', [
    z.object({ field: z.literal('condition'), rating: conditionRatingSchema.nullable() }),
    z.object({ field: z.literal('renovatedYear'), year: renovatedYearSchema.nullable() }),
    z.object({ field: z.literal('inspectedDate'), date: dateStringValidation.nullable() }),
    z.object({ field: z.literal('feature'), key: unitFeatureKeySchema, ticked: z.boolean() }),
    z.object({
        field: z.literal('utility'),
        key: utilityKeySchema,
        payer: utilityPayerSchema.nullable(),
    }),
]);
export const saveUnitProfileSchema = z.object({
    unitId: displayId,
    change: unitProfileChangeSchema,
});
export const saveAdjustmentValueSchema = z.object({
    propertyId: displayId,
    key: adjustmentKeySchema,
    cents: z
        .number()
        .int()
        .min(ADJUSTMENT_VALUE_CENTS_RANGE.min)
        .max(ADJUSTMENT_VALUE_CENTS_RANGE.max)
        .nullable(),
});
export const estimateInputSavedSchema = z.object({ success: z.literal(true) });
export const suggestAdjustmentValuesSchema = z.object({ propertyId: displayId });
export const suggestAdjustmentValuesOutputSchema = z.object({
    suggestionId: z.number().int(),
    valueCount: z.number().int(),
});
export const acceptAdjustmentScopeSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('key'), key: suggestibleAdjustmentKeySchema }),
    z.object({ kind: z.literal('all') }),
]);
export const acceptAdjustmentSuggestionSchema = z.object({
    propertyId: displayId,
    suggestionId: z.number().int().positive(),
    scope: acceptAdjustmentScopeSchema,
});
export const acceptAdjustmentSuggestionOutputSchema = z.object({
    written: z.number().int(),
    keptHand: z.number().int(),
});
export const adjustmentSuggestionRunOutputSchema = z.object({
    suggestionId: z.number().int(),
    createdAt: z.date(),
    grounded: z.boolean(),
    sources: z.array(estimateSourceSchema),
    searchEntryPoint: z.string().optional(),
    values: adjustmentSuggestionValuesSchema,
});
export const adjustmentSuggestionsOutputSchema = z.object({
    latest: adjustmentSuggestionRunOutputSchema.optional(),
    earlier: z.array(adjustmentSuggestionRunOutputSchema),
});
//# sourceMappingURL=rentRadarEstimateInputs.js.map